"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation updateOrganization($organization: OrganizationInput!) {
    updateOrganization(organization: $organization) {
      _id
      isSeasonTickets
      isTegIntegration
      validateMemberId
      tegClientID
      tegSecret
      tegURL
      ticketFormat
      ticketShareExpiration
      isWeb3Integration
      hiveIntegration {
        isHiveIntegration
      }
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=updateOrganization.mutation.js.map